import { gql } from '@apollo/client';

export const CREATE_COMPANY_TYPE_MUTATION = gql`
  mutation createCompanyType($name: String!, $description: String) {
    createCompanyType(name: $name, description: $description) {
      companyType {
        id
        currentVersion {
          id
          createdById
          description
          name
          status
          updatedById
          version
        }
      }
    }
  }
`;

export const ADD_COMPANY_TYPE_VERSION_MUTATION = gql`
  mutation addVersionToCompanyType(
    $companyTypeId: Int!
    $name: String!
    $description: String
    $publish: Boolean
  ) {
    addVersionToCompanyType(
      companyTypeId: $companyTypeId
      name: $name
      description: $description
      publish: $publish
    ) {
      companyTypeVersion {
        id
        name
      }
    }
  }
`;

export const EDIT_COMPANY_TYPE_VERSION_MUTATION = gql`
  mutation editDraftCompanyTypeVersion(
    $companyTypeId: Int!
    $name: String
    $description: String
    $publish: Boolean
  ) {
    editDraftCompanyTypeVersion(
      companyTypeId: $companyTypeId
      name: $name
      description: $description
      publish: $publish
    ) {
      companyTypeVersion {
        companyTypeId
        createdById
        description
        id
        name
        status
        updatedById
        version
      }
    }
  }
`;
